<div class="product-details-page" *ngIf="productDetailService.productDetail$ | async as product">
    <div class="container">
        <app-structured-data [json]="structuredDataProduct"></app-structured-data>
        <div class="row" *ngIf="product">
            <div class="col-12 col-md-7 col-xl-6 sticky-col">
                <app-product-slider
                    [campaignSplash]="product.productSplash"
                    [activeCampaigns]="product.activeCampaigns"
                    [activeSplashes]="product.activeSplashes"
                ></app-product-slider>
            </div>
            <div class="col-12 col-md-5 col-xl-4 offset-xl-1">
                <app-product-details (showMoreClicked)="showMoreComponent.open()">
                    <app-product-information [product]="product"></app-product-information>

                    @if (product.complementaryProductsEAN?.length) {
                        <app-product-complementary
                            [complementaryProducts]="product.complementaryProductsEAN"></app-product-complementary>
                    }
                </app-product-details>

                <div class="info-splashes" *ngIf="(splashes$ | async)?.length">
                    <hr class="kk-separator-line" />

                    <div *ngFor="let splash of splashes$ | async; trackBy: trackBySrc" class="info-splash">
                        <app-image [image]="splash" [height]="75" format="none"></app-image>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="container">
        <div class="usps">
            <app-usp></app-usp>
        </div>
    </div>
    <div class="ribbon">
        <app-relewise-slider
            [productId]="product.productNo"
            [type]="relewiseTypes.OtherAlsoSeenProducts"
            [headline]="'productDetail.headlines.othersSeen' | translateSafe"
        ></app-relewise-slider>
    </div>
    <div class="ribbon">
        <app-relewise-slider
            [productId]="product.productNo"
            [type]="relewiseTypes.OtherAlsoBoughtProducts"
            [headline]="'productDetail.headlines.othersBought' | translateSafe"
        ></app-relewise-slider>
    </div>
    <div class="ribbon">
        <app-relewise-slider
            [type]="relewiseTypes.LastSeen"
            [productId]="product.productNo"
            [compressed]="true"
            [headline]="'productDetail.headlines.lastSeen' | translateSafe"
        ></app-relewise-slider>
    </div>
</div>
